import React, { useCallback, useEffect, useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Row, Col, Button, Spinner, Badge } from "reactstrap";
import { Block, Icon } from "../../components/Component";
import FormSelect from "../form-components/SelectComponent";
import TaxConfigurationModal from "./TaxConfigurationModel";
import SignatureModal from "./SignatureModal";
import CropperComponent from "../components/CropperComponent";
import misc from "../../api/misc/dropDowns";
import { nanoid } from "nanoid";
import { Popover, Table } from "antd";
import type { TableColumnsType } from "antd";
import MaterialModal from "./MaterialModal";
import FormInput from "../form-components/InputComponent";
import { PaperClipOutlined } from "@ant-design/icons";
import deliveryAddressApis from "../../api/master/deliveryAddress";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { formatCurrency } from "../../utils/Utils";
import supplierApis from "../../api/master/supplier";
import {
  checkDeliveryAddress,
  checkNeedByDate,
  saveDraft,
} from "./draft-utility/saveDraft";
import { useNavigate } from "react-router";
import BulkMaterialUpload from "../purchase-requests/NewIndent/BulkMaterialUpload";

type Cess = {
  cessName: string;
  cessType?: string;
  cessPercentage?: string;
  cessAmount?: string;
};
interface TaxConfiguration {
  taxType: string;
  gstType?: string; //IGST or CGST+SGST
  cess?: Cess[];
}

interface CurrencyData {
  description: string;
  currency_code: string;
  currency_symbol: string;
  currency_format: string;
  example: string;
  id: any;
}

const RateContract_Materails: React.FC = (props: any) => {
  const [generalDetails, setGeneralDetails] = useState<any>();
  const [activeMaterial, setActiveMaterial] = useState<any>({
    action: null,
    index: null,
    item: null,
  });
  const [materialCategoryOptions, setMaterialCategoryOptions] = useState([]);
  const [sm, setSm] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [showConfigureTaxModel, setShowConfigureTaxModel] =
    useState<boolean>(false);
  const [taxConfiguration, setTaxConfiguration] = useState<TaxConfiguration>();
  const [allCurrencyData, setAllCurrencyData] = useState<CurrencyData[]>([]);
  const [signature, setSignature] = useState({
    isActive: false,
    label: "Authorised Signatory",
    image: null,
  });
  const [currency, setCurrency] = useState<CurrencyData>({
    description: "",
    currency_code: "INR",
    currency_symbol: "",
    currency_format: "",
    example: "",
    id: "",
  });
  const [showSignatureModel, setShowSignatureModel] = useState<boolean>(false);
  const [showCropModel, setShowCropModel] = useState<boolean>(false);
  const [needByDateType, setNeedByDateType] = useState<string>("");
  const [deliveryAddressType, setDeliveryAddressType] = useState<string>("");
  const [deliveryAddressList, setDeliveryAddressList] = useState<any>([]);
  const { control, reset, setValue, watch, handleSubmit } = useFormContext();
  const [disableSubmit, setDisableSubmit] = useState(false);
  const navigate = useNavigate();

  const previousFormDate = watch();
  const siteIdWatch = watch("siteId");

  const fetchDeliveryAddress = async () => {
    try {
      const { data, status, message } =
        await deliveryAddressApis.fetchDeliveryAddress();

      if (status) {
        setDeliveryAddressList(data);
      } else {
        console.log(message);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchDeliveryAddress();
    console.log("previousFormDate", previousFormDate);
    const {
      needByDateType,
      deliveryAddressType,
      taxConfigurationObj,
      signatureObj,
      currencyObj,
    } = previousFormDate;
    setGeneralDetails(previousFormDate);
    if (needByDateType) {
      setNeedByDateType(needByDateType);
    }
    if (deliveryAddressType) {
      setDeliveryAddressType(deliveryAddressType);
    }
    if (taxConfigurationObj) {
      onConfigureTaxSave(JSON.parse(taxConfigurationObj), false);
    }
    if (signatureObj) {
      setSignature(JSON.parse(signatureObj));
    }
    if (currencyObj) {
      // alert(currencyObj);
      setCurrency(JSON.parse(currencyObj));
    }
  }, []);

  const ShowAddressPopOver = ({ id }: any) => {
    if (!id) {
      return <></>;
    }
    let address = deliveryAddressList?.find((item: any) => item?.id == id);
    if (!address) {
      return <></>;
    }
    return (
      <ul>
        <li>
          <strong style={{ color: "#2263b3" }}>
            {address?.deliveryLocationName}
          </strong>
        </li>
        <li>{address?.addressLine1}</li>
        <li>{address?.addressLine2}</li>
        <li>
          {address?.city}, {address?.stateName}, {address?.countryName} -{" "}
          {address?.pincode}
        </li>
      </ul>
    );
  };

  useEffect(() => {
    setValue("signatureObj", JSON.stringify(signature));
  }, [signature]);

  const { fields, append, remove, update }: any = useFieldArray({
    control,
    name: "items",
  });

  const [columns, setColumns] = useState<TableColumnsType<any>>([
    // {
    //   ...Table.EXPAND_COLUMN,
    //   fixed: "left",
    // },
    {
      title: "#",
      key: "#",
      width: 50,
      fixed: "left",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Material Category",
      dataIndex: "materialCategoryLabel",
      key: "materialCategoryLabel",
      width: 150,
      fixed: "left",
    },
    {
      title: "Material Name",
      dataIndex: "materialLabel",
      key: "materialLabel",
      width: 220,
      fixed: "left",
      render: (text, record) => (
        <div className="d-flex align-items-center justify-content-between pe-2">
          <span>{record.materialLabel}</span>
          {record?.errorFlag == true ? (
            <Popover
              placement="left"
              content={
                <div>
                  <p>{record?.errorMessage?.join(", ")}</p>
                </div>
              }
              title={<span style={{ color: "red" }}>Failed</span>}
            >
              {/* <Icon
                name="info"
                color="danger"
                className="ms-1"
                style={{
                  cursor: "pointer",
                }}
              /> */}
              <Badge
                color="outline-danger"
                // className="ms-3"
                placement="right"
                style={{ cursor: "pointer" }}
              >
                <span>Error</span>
                <Icon name="info" />
              </Badge>
            </Popover>
          ) : (
            <></>
          )}
        </div>
      ),
    },
    {
      title: "HSN / SAC",
      dataIndex: "hsnCode",
      key: "hsnCode",
      width: 100,
    },
    {
      title: "UOM",
      dataIndex: "uomLabel",
      key: "uomLabel",
      width: 150,
      render: (text, record) => `${text} ${record?.uomLabel}`,
    },
    {
      title: "Unit Price",
      dataIndex: "unitPrice",
      key: "unitPrice",
      width: 150,
      render: (text) =>
        text ? formatCurrency(Number(text), currency?.currency_code) : "",
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      render: (text, record, index) => (
        <>
          <Button
            size="sm"
            color=""
            onClick={() => {
              setActiveMaterial({
                action: "edit",
                index: index,
                item: record,
              });
            }}
          >
            <Icon name="edit" />
          </Button>
          <Button size="sm" color="" onClick={() => remove(index)}>
            <Icon name="trash" />
          </Button>
          {!(
            generalDetails?.needByDateType == "Order Level" &&
            generalDetails?.deliveryAddressType == "Order Level" &&
            !record?.lineNo
          ) && (
            <Button
              size="sm"
              color=""
              onClick={() => {
                setActiveMaterial({
                  action: "edit",
                  index: index,
                  item: { ...record, id: nanoid(), needByDate: null },
                });
              }}
            >
              <Icon name="copy" />
            </Button>
          )}
        </>
      ),
    },
  ]);

  const onConfigureTaxSave = (data: any, updateField = true) => {
    setValue("taxConfigurationObj", JSON.stringify(data));
    setTaxConfiguration(data);
    setShowConfigureTaxModel(false);
    if (updateField) {
      fields.map((item: any, index: number, array: any) => {
        if (data?.gstType == "IGST") {
          let igst = item.cgst;
          let igstPercentage = item.cgstPercentage * 2;
          let igstAmount = item.cgstAmount * 2;
          let cgst = null;
          let sgst = null;
          let cgstPercentage = null;
          let cgstAmount = null;
          let sgstPercentage = null;
          let sgstAmount = null;
          update(index, {
            ...item,
            igst,
            igstPercentage,
            igstAmount,
            cgst,
            sgst,
            cgstPercentage,
            cgstAmount,
            sgstPercentage,
            sgstAmount,
          });
        } else if (data?.gstType == "CGST+SGST") {
          let igst = null;
          let igstPercentage = null;
          let igstAmount = null;
          let cgst = item.igst;
          let sgst = item.igst;
          let cgstPercentage = item.igstPercentage / 2;
          let cgstAmount = item.igstAmount / 2;
          let sgstPercentage = item.igstPercentage / 2;
          let sgstAmount = item.igstAmount / 2;

          update(index, {
            ...item,
            igst,
            igstPercentage,
            igstAmount,
            cgst,
            sgst,
            cgstPercentage,
            cgstAmount,
            sgstPercentage,
            sgstAmount,
          });
        }
      });
    }

    setColumns((pre) => {
      // if (!data?.cess?.length) return pre;
      let newColArray = [...pre].slice(0, 7);
      let additionalCol: any = [];
      if (data?.gstType == "IGST") {
        additionalCol.push({
          title: "IGST",
          children: [
            {
              title: "%",
              dataIndex: "igstPercentage",
              key: "igstPercentage",
              width: 100,
              render: (text: any) => (text ? `${Number(text)}%` : ""),
            },
            {
              title: "Amount",
              dataIndex: "igstAmount",
              key: "igstAmount",
              width: 150,
              render: (text: any, record: any) => {
                return (
                  <p className="justify-end">
                    {text
                      ? formatCurrency(Number(text), currency?.currency_code)
                      : ""}
                  </p>
                );
              },
            },
          ],
        });
      } else {
        additionalCol.push({
          title: "CGST",
          children: [
            {
              title: "%",
              dataIndex: "cgstPercentage",
              key: "cgstPercentage",
              width: 100,
              render: (text: any) => (text ? `${Number(text)}%` : ""),
            },
            {
              title: "Amount",
              dataIndex: "cgstAmount",
              key: "cgstAmount",
              width: 150,
              render: (text: any, record: any) => {
                return (
                  <p className="justify-end">
                    {text
                      ? formatCurrency(Number(text), currency?.currency_code)
                      : ""}
                  </p>
                );
              },
            },
          ],
        });
        additionalCol.push({
          title: "SGST",
          children: [
            {
              title: "%",
              dataIndex: "sgstPercentage",
              key: "sgstPercentage",
              width: 100,
              render: (text: any) => (text ? `${Number(text)}%` : ""),
            },
            {
              title: "Amount",
              dataIndex: "sgstAmount",
              key: "sgstAmount",
              width: 150,
              render: (text: any, record: any) => {
                return (
                  <p className="justify-end">
                    {text
                      ? formatCurrency(Number(text), currency?.currency_code)
                      : ""}
                  </p>
                );
              },
            },
          ],
        });
      }
      if (data?.cess.length) {
        data.cess.forEach((item: any) => {
          if (!item.cessName) return;
          additionalCol.push({
            title: item.cessName,
            children: [
              {
                title: "%",
                dataIndex: item.cessName,
                key: item.cessName,
                width: 100,
                render: (text: any) => `${text || 0}%`,
              },
              {
                title: "Amount",
                dataIndex: `${item.cessName}Amount`,
                key: `${item.cessName}Amount`,
                width: 150,
              },
            ],
          });
        });
      }
      additionalCol.push({
        title: "Line Total",
        key: "lineTotal",
        width: 150,
        render: (text: any, record: any) => {
          return (
            <p className="justify-end">
              {isNaN(Number(text))
                ? ""
                : formatCurrency(Number(text), currency?.currency_code)}
            </p>
          );
        },
      });
      // additionalCol.push({
      //   title: "Status",
      //   dataIndex: "errorFlag",
      //   key: "errorFlag",
      //   fixed: "right",
      //   width: 90,
      //   render: (text: any, record: any) => {
      //     if (record?.errorFlag == true) {
      //       return (
      //         <Popover
      //           placement="left"
      //           content={
      //             <div>
      //               <p>{record?.errorMessage?.join(", ")}</p>
      //             </div>
      //           }
      //           title={<span style={{ color: "red" }}>Failed</span>}
      //         >
      //           <Badge
      //             color="outline-danger"
      //             // className="ms-3"
      //             placement="right"
      //             style={{ cursor: "pointer" }}
      //           >
      //             <span>Error</span>
      //             <Icon name="info" />
      //           </Badge>
      //         </Popover>
      //       );
      //     } else
      //       return (
      //         <Badge
      //           color="outline-success"
      //           // className="ms-3"
      //           placement="right"
      //           style={{ cursor: "pointer" }}
      //         >
      //           <Icon name="check" />
      //           <span>Success</span>
      //         </Badge>
      //       );
      //   },
      // });
      additionalCol.push({
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 150,
        render: (text: any, record: any, index: any) => (
          <>
            <Button
              size="sm"
              color=""
              onClick={() => {
                setActiveMaterial({
                  action: "edit",
                  index: index,
                  item: record,
                });
              }}
            >
              <Icon name="edit" />
            </Button>
            <Button size="sm" color="" onClick={() => remove(index)}>
              <Icon name="trash" />
            </Button>
            {(generalDetails?.needByDateType == "Line Level" ||
              generalDetails?.deliveryAddressType == "Line Level") &&
              !record?.lineNo && (
                <Button
                  size="sm"
                  color=""
                  onClick={() => {
                    setActiveMaterial({
                      action: "edit",
                      index: null,
                      item: {
                        ...record,
                        id: nanoid(),
                        needBYDate: null,
                      },
                    });
                  }}
                >
                  <Icon name="copy" />
                </Button>
              )}
          </>
        ),
      });

      return newColArray.concat(additionalCol);
    });
  };

  const updateColumnsWithCurrencySymbol = useCallback(() => {
    setColumns((prevColumns) => {
      return prevColumns.map((col: any) => {
        if (col.dataIndex == "unitPrice" || col.dataIndex == "amount") {
          return {
            ...col,
            render: (text: any) => (
              <div className="justify-end">
                {isNaN(Number(text))
                  ? ""
                  : formatCurrency(Number(text), currency?.currency_code)}
              </div>
            ),
          };
        }
        if (col.key == "lineTotal") {
          return {
            title: "Line Total",
            key: "lineTotal",
            dataIndex: "lineTotal",
            width: 150,
            render: (text: any, record: any) => {
              return (
                <p className="justify-end">
                  {isNaN(Number(text))
                    ? ""
                    : formatCurrency(Number(text), currency?.currency_code)}
                </p>
              );
            },
          };
        }
        if (col.children) {
          let children = col.children.map((child: any) => {
            if (child.title == "Amount") {
              return {
                ...child,
                render: (text: any) => (
                  <div className="justify-end">
                    {isNaN(Number(text))
                      ? ""
                      : formatCurrency(Number(text), currency?.currency_code)}
                  </div>
                ),
              };
            }
            return child;
          });
          return {
            ...col,
            children,
          };
        }
        return col;
      });
    });
  }, [currency]);

  useEffect(() => {
    updateColumnsWithCurrencySymbol();
  }, [currency, updateColumnsWithCurrencySymbol]);

  const updateColumnsWithNeedByDateType = useCallback(() => {
    setColumns((prevColumns) => {
      return prevColumns.map((col: any) => {
        if (
          col.dataIndex === "needByDate" &&
          generalDetails?.needByDateType != "Line Level"
        ) {
          return {
            ...col,
            hidden: true,
          };
        } else if (
          col.dataIndex === "needByDate" &&
          generalDetails?.needByDateType == "Line Level"
        ) {
          return {
            ...col,
            hidden: false,
          };
        } else if (col.key == "operation") {
          return {
            title: "Action",
            key: "operation",
            fixed: "right",
            width: 150,
            render: (text: any, record: any, index: any) => (
              <>
                <Button
                  size="sm"
                  color=""
                  onClick={() => {
                    setActiveMaterial({
                      action: "edit",
                      index: index,
                      item: record,
                    });
                  }}
                >
                  <Icon name="edit" />
                </Button>
                <Button size="sm" color="" onClick={() => remove(index)}>
                  <Icon name="trash" />
                </Button>
                {!(
                  generalDetails?.needByDateType == "Order Level" &&
                  generalDetails?.deliveryAddressType == "Order Level"
                ) &&
                  !record?.lineNo && (
                    <Button
                      size="sm"
                      color=""
                      onClick={() => {
                        setActiveMaterial({
                          action: "edit",
                          index: null,
                          item: {
                            ...record,
                            id: nanoid(),
                            needByDate: null,
                            deliveryAddressId: null,
                            quoteShortListId: null,
                            supplierQuoteLineId: null,
                          },
                        });
                      }}
                    >
                      <Icon name="copy" />
                    </Button>
                  )}
              </>
            ),
          };
        }
        return col;
      });
    });
  }, [generalDetails]);

  useEffect(() => {
    updateColumnsWithNeedByDateType();
  }, [generalDetails, setGeneralDetails]);

  const configColumns = (cols: any[]) => {
    return cols.filter((col) => {
      // Hide the "unitPrice" column if priceSlab is false
      if (col.key === "unitPrice" && previousFormDate?.priceSlabs === "true") {
        return false;
      }
      return true;
    });
  };

  const addNewRow = () => {
    setActiveMaterial({
      action: "add",
      index: null,
      item: null,
    });
  };

  const fetchCurrencyData = async () => {
    try {
      const res = await misc.getCurrencyTypes();
      const { data, status } = res;
      if (status) {
        let allCurrencyData = data.map((item: any) => {
          return {
            description: item.description,
            currency_code: item.currency_code,
            currency_symbol: item.currency_symbol,
            currency_format: item.currency_format,
            example: item.example,
            id: item.id,
          };
        });
        setAllCurrencyData(allCurrencyData);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchCategorys = async () => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        const categoryOption = data.map((item: any) => ({
          label: item.category,
          value: item.id.toString(),
        }));
        setMaterialCategoryOptions(categoryOption);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  useEffect(() => {
    fetchCategorys();
    fetchCurrencyData();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  return (
    <>
      <Block>
        <form className="form-validate" onSubmit={handleSubmit(() => {})}>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <button
                className="btn-dim btn btn-outline-primary"
                onClick={() => setShowConfigureTaxModel(true)}
                type="button"
              >
                <Icon name="percent"></Icon> &nbsp; &nbsp; Configure TAX &nbsp;
              </button>
            </div>
            <div>
              <BulkMaterialUpload
                moduleKey={"po-creation"}
                append={(data: any) => {
                  append(data);
                }}
                extra={{
                  fields,
                  formData: {
                    ...previousFormDate,
                    igstFlag: taxConfiguration?.gstType == "IGST" ? 1 : 0,
                  },
                }}
              />
            </div>
          </div>

          <Row>
            <div className="table-responsive poTable">
              <div style={{ width: screenSize - 120 + "px", margin: "auto" }}>
                {columns && (
                  <Table
                    className="customTable"
                    columns={configColumns(columns)}
                    dataSource={fields}
                    rowClassName={(record: any) => {
                      return record?.errorFlag == true ? "error-tableRow" : "";
                    }}
                    scroll={{ x: "max-content" }}
                    expandable={{
                      expandedRowRender: (record: any) => (
                        console.log("record", record),
                        (
                          <div className="expandableBody">
                            <div style={{ flex: 1, textAlign: "left" }}>
                              <p style={{ margin: 0 }}>{record.description}</p>

                              {record.file && record.file[0] && (
                                <>
                                  <div style={{ marginTop: "15px" }}></div>
                                  <h6>Delivery Address</h6>

                                  <div>
                                    <PaperClipOutlined /> &nbsp;
                                    <a
                                      href={URL.createObjectURL(record.file[0])}
                                      download={record.file[0]?.name}
                                    >
                                      {record.file[0]?.name}
                                    </a>
                                  </div>
                                </>
                              )}
                            </div>
                            {record.priceSlabArray.length > 0 && (
                              <div className="lineAddress" style={{ flex: 1 }}>
                                <h6>Price Slab</h6>
                                <Table
                                  className="customTable"
                                  columns={[
                                    {
                                      title: "Minimum Qty",
                                      key: "maxquantity",
                                      dataIndex: "minquantity",
                                    },
                                    {
                                      title: "Maximum Qty",
                                      key: "maxquantity",
                                      dataIndex: "maxquantity",
                                    },
                                    {
                                      title: "Price per Unit",
                                      key: "unitPrice",
                                      dataIndex: "unitPrice",
                                      render: (value: any) => (
                                        <>{value+" "+"RM"}</>
                                      )
                                    },
                                  ]}
                                  dataSource={record.priceSlabArray}
                                  bordered
                                  size="small"
                                  pagination={false}
                                />
                              </div>
                            )}
                          </div>
                        )
                      ),
                    }}
                    locale={{
                      emptyText: (
                        <span
                          style={{
                            height: "300px",
                            color: "#333",
                            fontSize: "16px",
                          }}
                        >
                          Please click on "Add New Item" to add Rate Contract
                          lines.
                        </span>
                      ),
                    }}
                    bordered
                    size="small"
                    pagination={false}
                  />
                )}
              </div>

              <Row
                style={{
                  margin: "20px",
                }}
              >
                <Col className="justify-between">
                  <a onClick={addNewRow} className="addNewItem">
                    <Icon name="plus-round" />
                    <span>Add New Item</span>
                  </a>
                  {fields?.find((line: any) => line?.errorFlag)?.errorFlag && (
                    <></>
                  )}
                </Col>
              </Row>
            </div>
          </Row>

          <div className="actions clearfix">
            <ul>
              <li>
                <Button
                  title={fields.length === 0 ? "Please add materials" : ""}
                  color="primary"
                  type="submit"
                  disabled={
                    fields?.length == 0 ||
                    fields?.find((line: any) => line?.errorFlag)?.errorFlag
                  }
                  onClick={() => {
                    if (fields.length == 0) {
                      Swal.fire({
                        icon: "info",
                        title: "Material",
                        text: "Please Add Material",
                      });
                      return;
                    }
                    props.next();
                  }}
                >
                  Next
                </Button>
              </li>
              <li>
                <Button
                  color="primary"
                  onClick={props.prev}
                  className="btn-dim btn btn-secondary"
                >
                  Previous
                </Button>
              </li>
              {fields.length > 0 && (
                <li>
                  {disableSubmit ? (
                    <Button color="secondary" type="button">
                      <Spinner size="sm" color="light" />
                    </Button>
                  ) : (
                    <Button
                      color="secondary"
                      onClick={() =>
                        saveDraft(
                          previousFormDate,
                          previousFormDate?.type == "draft",
                          navigate,
                          setDisableSubmit
                        )
                      }
                      disabled={
                        fields?.find((line: any) => line?.errorFlag)?.errorFlag
                      }
                      className="btn btn-secondary"
                    >
                      Save as Draft
                    </Button>
                  )}
                </li>
              )}
            </ul>
          </div>
          <span style={{ display: "none" }}>
            <Col lg="4" className="inline-select">
              <label className="form-label" style={{ margin: "0" }}>
                Currency
              </label>
              <FormSelect
                name="currency"
                label=""
                options={allCurrencyData.map((item: any) => ({
                  label: item.description,
                  value: item.currency_code,
                }))}
                required={false}
                placeholder="Indian Rupee"
                onChange={(value) => {
                  const currency = allCurrencyData.find(
                    (item) => item.currency_code === value
                  );
                  if (!currency) return;
                  setValue("currencyObj", JSON.stringify(currency));
                  // alert(JSON.stringify(currency));
                  setCurrency(currency);
                }}
              />
            </Col>
            <FormInput name="currencyObj" label="" type="text" />
            <FormInput name="taxConfigurationObj" label="" type="text" />
            <FormInput name="signatureObj" label="" type="text" />
            <Col lg="4" style={{ marginTop: "10px" }} className="inline-select">
              <label className="form-label" style={{ margin: "0" }}>
                Currency Format ( e.g ) :
              </label>
              <p
                className="text-primary"
                style={{ fontSize: "18px", marginLeft: "10px" }}
              >
                {currency?.example || "₹1,23,456.78"}
              </p>
            </Col>
          </span>
        </form>
      </Block>
      {showConfigureTaxModel && (
        <TaxConfigurationModal
          data={taxConfiguration}
          isOpen={showConfigureTaxModel}
          setIsOpen={setShowConfigureTaxModel}
          onSave={onConfigureTaxSave}
        />
      )}
      {showSignatureModel && (
        <SignatureModal
          modal={showSignatureModel}
          toggle={() => setShowSignatureModel(!showSignatureModel)}
          onSave={(data: string) => {
            setSignature((pre: any) => {
              return { ...pre, image: data };
            });
            setShowSignatureModel(false);
          }}
        />
      )}
      {showCropModel && (
        <CropperComponent
          modal={showCropModel}
          toggle={() => setShowCropModel(!showCropModel)}
          onSave={(data: string) => {
            setSignature((pre: any) => {
              return { ...pre, image: data };
            });
            setShowCropModel(false);
          }}
        />
      )}
      {activeMaterial.action && (
        <MaterialModal
          modal={!!activeMaterial.action}
          closeModal={() => {
            setActiveMaterial({
              action: null,
              index: null,
              item: null,
            });
          }}
          taxConfiguration={taxConfiguration}
          materialCategoryOptions={materialCategoryOptions}
          append={(data: any) => {
            for (let i = 0; i < fields.length; i++) {
              let item: any = fields[i];
              if (
                item.materialName == data.materialName &&
                checkDeliveryAddress(
                  previousFormDate?.deliveryAddressType,
                  item.deliveryAddressId,
                  data.deliveryAddressId
                ) &&
                checkNeedByDate(
                  previousFormDate?.needByDateType,
                  item.needByDate,
                  data.needByDate
                )
              ) {
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "Material Already Added",
                });
                return;
              }
            }

            append(data);
          }}
          update={(index: any, data: any) => {
            console.log("update", index, data);
            const ItemsList = [...fields];
            const _data = ItemsList?.filter(
              (item: any, idx) => idx != index
            )?.find((item: any) => {
              if (
                item.materialName == data.materialName &&
                checkDeliveryAddress(
                  previousFormDate?.deliveryAddressType,
                  item.deliveryAddressId,
                  data.deliveryAddressId
                ) &&
                checkNeedByDate(
                  previousFormDate?.needByDateType,
                  item.needByDate,
                  data.needByDate
                )
              )
                return true;
            });

            if (_data) {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Material Already Added",
              });
              return;
            }
            update(index, { ...data, errorFlag: false, errorMessage: [] });
          }}
          formData={activeMaterial}
          materialsList={fields?.map((row: any) =>
            row?.materialName?.toString()
          )}
          priceSlab={previousFormDate?.priceSlabs}
          needByDateType={needByDateType}
          siteId={siteIdWatch}
          deliveryAddressType={watch("deliveryAddressType")}
        />
      )}
    </>
  );
};

export default RateContract_Materails;
